import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

function RestaurantCard({ restaurant }) {
  return (
    <Card sx={{ width: 320 }}>
      <CardMedia
        sx={{ height: 140, width: '100%' }}
        image={restaurant.image}
        title="restaurant menu"
      />
      <CardContent>
        <Typography variant="h6" color="black" textAlign="center">
          {restaurant.title}
        </Typography>
      </CardContent>
    </Card>
  );
}

RestaurantCard.propTypes = {
  restaurant: PropTypes.shape({
    id: PropTypes.number,
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
};

RestaurantCard.defaultProps = {
  restaurant: {},
};

export default RestaurantCard;
